import BaseLayer from "./BaseLayer";
import {drawRectangle, imagetoCanvasPosHelper, plotCounties} from "../utils/map_utils";
import {TileViewerConstants} from "../../../utils/const";

class Take2Islands extends BaseLayer {
    id = "take2Islands";
    label = "Take 2 Islands";
    defaultVisible = this.props.tileViewerState[this.id];

    onFeatureSelect = () => undefined;

    draw = () => new Promise((resolve, reject) => {
        let {islands, deviceSettings, take2Islands, textColor} = this.props;
        let {y_fields} = this.props.slide;
        let index = 0;
        if (take2Islands) {
            for (let i = 0; i < take2Islands.length; i++) {
                let rectStartPoint = imagetoCanvasPosHelper({device_settings: deviceSettings}, this.props.slide,
                    (take2Islands[i]["islandBoundary"])["x"], y_fields -
                    (take2Islands[i]["islandBoundary"])["y"]);
                let rectEndPoint = imagetoCanvasPosHelper({device_settings: deviceSettings}, this.props.slide,
                    take2Islands[i]["islandBoundary"]["x"] + take2Islands[i]["islandBoundary"]["width"],
                    y_fields - take2Islands[i]["islandBoundary"]["y"] -
                    take2Islands[i]["islandBoundary"]["height"]);
                let bounds = [
                    [rectStartPoint.x, rectStartPoint.y],
                    [rectEndPoint.x, rectStartPoint.y],
                    [rectEndPoint.x, rectEndPoint.y],
                    [rectStartPoint.x, rectEndPoint.y],
                    [rectStartPoint.x, rectStartPoint.y]
                ];
                index = (index + 1) % 4;
                drawRectangle(bounds, this.layer.getSource(), false, 4, TileViewerConstants.BLUE[index],
                    "", textColor);
            }
        }
        if (islands.length > 0 && islands[0]["counties"]) {
            plotCounties(islands, {device_settings: deviceSettings}, this.props.slide,
                this.layer.getSource(), 2, textColor);
        }
        resolve();
    });
}

export default Take2Islands;
